<branding-wrapper 
  *ngIf="!!fullData && !!listInfo && !loading && listInfo.excludedFieldIds || [] as excluded"
  [isConfigure]="!!configureMode"
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'"
  [brandingData]="brandingData"
  (change)="change.emit($event)"
>
  <div class="event-list-wrapper">
    <ng-content select=".header-text"></ng-content>
    <branding-text-block *ngIf="!configureMode && !!listInfo.homePageData?.headerText?.text" 
      [brandingText]="listInfo.homePageData.headerText"
    ></branding-text-block>

    <div class="account-holder" *ngIf="!!fullData.accountName || !!fullData.accountLogoUrl">
      <photo [size]="36" [data]="{ photoURL: fullData.accountLogoUrl, title: fullData.accountName }"></photo>
      <div *ngIf="!!fullData.accountName" class="account-name">{{ fullData.accountName }}</div>
    </div>
    <h1 class="lists-title" *ngIf="!!listInfo.title && !excluded.includes('eventListName')">{{ listInfo.title }}</h1>
    <div class="lists-description" [innerHTML]="helpers.strWithBreak(listInfo.description)" *ngIf="!!listInfo.description && !excluded.includes('description')"></div>
    <add-to-cal *ngIf="!excluded.includes('calendar')" [canSubscribe]="true" [shareCode]="fullData.id" [entityId]="fullData.id" [entityType]="'eventList'" [eventId]="'NA'" [addText]="'Subscribe to this calendar'" [notPublished]="listInfo.status !== 'published'" [notPublishedMessage]="'This event list is not currently published.  The subscribe to calendar URL will only work when an event list is published.'"></add-to-cal>
    <joi-nav-wrapper *ngIf="showTabs"
      [menuItems]="tabsMenu"
      [menuMap]="listInfo.tabNames"
      [publicStyle]="true"
      [selectedId]="selectedTab" 
      (selectItem)="selectedTab = $event"
    ></joi-nav-wrapper>
    <event-list-instances *ngIf="!!selectedTab" [loading]="loading" [missingName]="listInfo.tabNames[selectedTab] | lowercase"
      [instanceList]="selectedTab === UPCOMING ? eventLists.upcoming : eventLists.past" (editEventThumbnail)="editEventThumbnail.emit($event)"></event-list-instances>
    <made-with-joi *ngIf="showJoi" class="made-with-joi"></made-with-joi>
    <ng-content select=".footer-text"></ng-content>
    <branding-text-block *ngIf="!configureMode && !!listInfo.homePageData?.textBlock?.text" [ngStyle]="{ marginBottom: brandingData?.social?.social.length ? '0px' : '40px' }"
      [brandingText]="listInfo.homePageData.textBlock"
    ></branding-text-block>
    <ng-content select=".slider-block"></ng-content>
    <slider-images *ngIf="!configureMode && !!listInfo.homePageData?.sliderImages?.length" [sliderImages]="listInfo.homePageData.sliderImages"></slider-images>
  </div>
</branding-wrapper>